import React, { useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';

const FitScoreBadge = ({ score, tier, highlights }) => {
  const [displayPct, setDisplayPct] = useState(0);

  // Convert 0-9 score to percentage
  const targetPct = score > 0 ? parseFloat(((score / 9) * 100).toFixed(1)) : 0;

  // Count up animation
  useEffect(() => {
    let start = 0;
    const duration = 1500;
    const increment = targetPct / (duration / 16);

    const timer = setInterval(() => {
      start += increment;
      if (start >= targetPct) {
        setDisplayPct(targetPct);
        clearInterval(timer);
      } else {
        setDisplayPct(parseFloat(start.toFixed(1)));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [targetPct]);

  const getTierColor = (tier) => {
    const t = tier.toUpperCase();
    if (t.includes('ELITE'))    return '#00E676';
    if (t.includes('STRONG'))   return '#00C853';
    if (t.includes('GOOD'))     return '#FFD600';
    if (t.includes('MARGINAL')) return '#FFB300';
    return '#EF5350';
  };

  const tierColor = getTierColor(tier);

  return (
    <div className="flex flex-col items-end gap-3">
      {/* Label */}
      <div className="text-white font-bold text-sm tracking-wider">
        PROGRAM FIT SCORE
      </div>

      {/* Percentage */}
      <div
        className="font-rajdhani font-bold pulse-glow"
        style={{ fontSize: '72px', lineHeight: '1', color: tierColor }}
      >
        {displayPct}%
      </div>

      {/* Tier */}
      <div className="font-rajdhani font-bold text-lg tracking-wide" style={{ color: tierColor }}>
        {tier.toUpperCase()}
      </div>

      {/* Highlights */}
      <div className="flex flex-col gap-2 mt-2">
        {highlights.map((highlight, index) => (
          <div key={index} className="flex items-center gap-2">
            <ChevronRight size={16} style={{ color: tierColor }} className="flex-shrink-0" />
            <span className="text-[#B0BEC5] text-sm">{highlight}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FitScoreBadge;
